import * as React from 'react';

import { cn } from '../../lib/utils';
import { Input } from '../shadcn/input';

/**
 * A Lebanese phone number: the `+961` is drawn in the box and the visitor
 * types the rest — "70 123 456", "03 123 456".
 *
 * The prefix is part of the picture, not of the value: what the input holds
 * is only what was typed, and the shared `phone` rule turns that into
 * `+961…` when the form is sent. So a pasted "+961 70 123 456" or a local
 * "03-123 456" both still work.
 *
 * Takes everything an `Input` does and passes it on, so `Field` binds it the
 * same way: `<Field name="phone" label="Phone"><PhoneInput /></Field>`.
 */
function PhoneInput({ className, ...props }: Omit<React.ComponentProps<'input'>, 'type'>) {
  return (
    <div data-slot="phone-input" className="relative">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-base text-ink-muted md:text-sm"
      >
        +961
      </span>
      <Input
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        placeholder="70 123 456"
        className={cn('pl-13', className)}
        {...props}
      />
    </div>
  );
}

export { PhoneInput };
